import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
// import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react"; // Moved to streaming pages
// Clerk removed - not being used

import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import { AuthContextProvider } from './contexts/authContext';
import './i18n';

// Agora RTC client initialization moved to streaming pages to reduce initial bundle size
// const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

const children = (
	<ThemeContextProvider>
		<Router>
			<React.StrictMode>
				<AuthContextProvider>
					<App />
				</AuthContextProvider>
			</React.StrictMode>
		</Router>
	</ThemeContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
